import React, { useState } from "react";
import { TableCell, TableRow } from "@mui/material";

import SecondaryButton from "@/main/components/shared/button/secondaryButton";
import BoxGrid from "@/main/components/shared/boxGrid/boxGrid";
import { getTranslateByKey } from "@/main/services/utils";
import * as S from "./styles";
import SupplierCompanyBuyerRegister from "./supplierCompanyBuyerRegister";
import { KeyValue } from "@/main/models/common";

export interface ISupplierCompanyBuyerInfo {
	guid: string;
	buyerName: string;
	userDateTime: string;
	companyTypeName: string;
}

interface Props {
	watcherCountry: KeyValue | null;
	guidSupplier: string | null;
	supplierCompanyBuyerGrid: ISupplierCompanyBuyerInfo[];
	setSupplierCompanyBuyerGrid: React.Dispatch<React.SetStateAction<ISupplierCompanyBuyerInfo[]>>;
	setSupplierCompanyBuyerDeleteItem: (cb: (data: any[]) => any[]) => void;
}

function SupplierCompanyBuyerInfo({
	watcherCountry,
	guidSupplier,
	supplierCompanyBuyerGrid,
	setSupplierCompanyBuyerGrid,
	setSupplierCompanyBuyerDeleteItem,
}: Props) {
	const [open, setOpen] = useState<boolean>(false);
	const rowHeaders = [
		getTranslateByKey("information.companyType"),
		getTranslateByKey("information.buyerCompany"),
		getTranslateByKey("information.userDateTime"),
		getTranslateByKey("information.actions"),
	];

	function closeModal() {
		setOpen(false);
	}

	function handleSupplierCompanyBuyerInfo(id: string) {
		setSupplierCompanyBuyerDeleteItem((prev) => [...prev, { guid: id }]);
		setSupplierCompanyBuyerGrid((prevState) => {
			const index = prevState.findIndex((item) => item.guid === id);
			prevState.splice(index, 1);
			return [...prevState];
		});
	}
	return (
		<>
			<S.Container>
				<S.ContainerTitle>
					<S.HeaderText>{getTranslateByKey("information.SupplierbuyerCompany")}</S.HeaderText>
					<SecondaryButton
						style={{
							padding: ".2rem .8rem",
							marginTop: ".6rem",
						}}
						onClick={() => setOpen(true)}
						id="id-register-button-addSupplierbuyerCompany"
					>
						{getTranslateByKey("information.add")}
					</SecondaryButton>
				</S.ContainerTitle>
				{supplierCompanyBuyerGrid.length > 0 && (
					<BoxGrid rowHeaders={rowHeaders} maxHeight={"390px"}>
						{supplierCompanyBuyerGrid.map((buyer) => (
							<TableRow key={buyer.guid}>
								<TableCell width="25%">{buyer.companyTypeName}</TableCell>
								<TableCell width="50%">{buyer.buyerName}</TableCell>
								<TableCell width="20%">{buyer.userDateTime}</TableCell>
								<TableCell width="5%" align="center">
									<S.IconClose onClick={() => handleSupplierCompanyBuyerInfo(buyer.guid)} />
								</TableCell>
							</TableRow>
						))}
					</BoxGrid>
				)}
			</S.Container>
			<SupplierCompanyBuyerRegister
				open={open}
				closeModal={closeModal}
				watcherCountry={watcherCountry}
				guidSupplier={guidSupplier}
				setSupplierCompanyBuyerGrid={setSupplierCompanyBuyerGrid}
			/>
		</>
	);
}

export default SupplierCompanyBuyerInfo;
